import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Link from "next/link";

interface Props {
  isDefaultLanguage: boolean;
}

export const RefreshInfo = ({ isDefaultLanguage }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col p-4 mt-1 bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark border rounded-lg">
      <div>
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_A_HEADER}</Typography>
      </div>
      <TextLine />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_A}</Typography>
      <div className="flex mt-4">
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_B_HEADER}</Typography>
      </div>
      <TextLine />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_B}</Typography>
      <div className="flex mt-4">
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_C_HEADER}</Typography>
      </div>
      <TextLine />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_C}</Typography>
      <div className="flex mt-4">
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_D_HEADER}</Typography>
      </div>
      <TextLine />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_D}</Typography>
      <Link
        prefetch={false}
        href="https://vff.no/fondshandboken/artikler/aksjefond"
        target="_blank"
        className="flex underline items-start"
      >
        <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_D_LINK}</Typography>
      </Link>
      <div className="flex mt-4">
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_E_HEADER}</Typography>
      </div>
      <TextLine />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_E}</Typography>
      <Link
        prefetch={false}
        href="https://vff.no/fondshandboken/artikler/rentefond"
        target="_blank"
        className="flex underline items-start"
      >
        <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_E_LINK}</Typography>
      </Link>
      <div className="flex mt-4">
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_F_HEADER}</Typography>
      </div>
      <TextLine />
      <div>
        <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_F}</Typography>
      </div>
      <Link
        prefetch={false}
        href="https://vff.no/fondshandboken/artikler/kombinasjonsfond"
        target="_blank"
        className="flex underline items-start"
      >
        <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_F_LINK}</Typography>
      </Link>
      <div className="flex mt-4">
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_G_HEADER}</Typography>
      </div>
      <TextLine />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_G}</Typography>
      <br />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_G_2}</Typography>
      <Link
        prefetch={false}
        href="https://vff.no/fondshandboken/tema/hva-kan-jeg-tjene-og-tape"
        target="_blank"
        className="flex underline items-start"
      >
        <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_G_LINK}</Typography>
      </Link>
      <br />
      <div className="flex mt-4">
        <Typography variant="H6">{texts.PAGE_3_INFO_TEXT_H_HEADER}</Typography>
      </div>
      <TextLine />
      <Typography variant="Body">{texts.PAGE_3_INFO_TEXT_H}</Typography>
    </div>
  );
};
